import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Stakeholder } from '../../types/stakeholder.types';
import { useAppQuery } from '../use-app-query.hook';
import { useLocale } from '../use-locale.hook';

export const useStakeholder = ({
  companyId,
  stakeholderId,
}: {
  companyId: string;
  stakeholderId: string;
}) => {
  const { locale } = useLocale();
  const queryClient = useQueryClient();

  const { data: stakeholder, isLoading } = useAppQuery({
    queryKey: [QueryKey.GET_STAKEHOLDER, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<Stakeholder>(
        {
          endpoint: BackendRoute.COMPANIES,
          routePath: [companyId, 'stakeholders', stakeholderId],
        },
        { locale },
      ),
    enabled: !!companyId && !!stakeholderId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_STAKEHOLDER] });
  }, [queryClient]);

  return {
    invalidateQuery,
    stakeholder,
    isLoading,
  };
};
